import { stagesComponent } from "./stages.component";
import { StageService } from "./stages.service";

export const stages = angular
  .module("components.stages", [])
  .component("stages", stagesComponent)
  .service("StageService", StageService)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("stages", {
      parent: "app",
      url: "/user/:memberId/stages/:stageId/tasks",
      breadcrumbName: "Member Stage tasks",
      parentState: "home",
      component: "stages",
      resolve: {
        userDetails($stateParams, UserService) {
          "ngInject";
          return UserService.getUserDetailsById($stateParams.memberId);
        },
        details($stateParams, StageService) {
          "ngInject";
          return StageService.getVeteranStageTasks(
            $stateParams.stageId,
            $stateParams.memberId
          ).then(({ details }) => details);
        },
      },
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/stages/stages.module.js